'use client'
import { Offer } from '@/src/types/offers'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import { useIsHeya } from '@/src/hooks/useThemeKey'
import { useTranslations } from 'next-intl'
import HotelsHomeMobile from './home'

interface HotelsHomeMobileContainerProps {
    locale: string
    offers: Offer[]
}

const HotelsHomeMobileContainer = ({ locale, offers }: HotelsHomeMobileContainerProps) => {
    const t = useTranslations('hotels')
    const isHeya = useIsHeya()

    return (
        <>
            <ErrorBoundaryWrapper identifier="hotels-home-mobile">
                <HotelsHomeMobile
                    title={t('homeTitle')}
                    subtitle={t('homeSubtitle')}
                    offers={offers}
                    locale={locale}
                    heyaCopy={
                        isHeya
                            ? {
                                badge: t('heya.badge'),
                                headingLead: t('heya.headingLead'),
                                headingAccent: t('heya.headingAccent'),
                                intro: t('heya.intro')
                            }
                            : undefined
                    }
                />
            </ErrorBoundaryWrapper>
        </>
    )
}

export { HotelsHomeMobileContainer }
export default HotelsHomeMobileContainer
